<template lang="">
  <div class="flex-fill">
    <section v-if="banner.length"  id="banner" class="">
      <div class="banner">
        <carousel loop autoplay centerMode :autoplayTimeout="5000" adjustableHeight :speed="2000" :perPage="1" paginationActiveColor="var(--secondary-theme)" :paginationSize="15" :paginationPosition="'bottom-overlay'">
          <slide v-for="(p, i) in banner" :key="i + '-img-banner'">
            <div class="hero-banner d-flex flex-column justify-content-end" :style="{ 'background-image': 'linear-gradient(90deg, rgba(23, 66, 158, 0.4) 0%, rgba(0, 0, 0, 0) 100%), url(' + p.img_banner.url + ')', 'background-repeat': 'no-repeat', 'background-size': 'cover', 'background-position': 'center' }">
              <div class="mb-25" v-if="p.description">
                <div class="text-line-3 mb-10 hero-caption">{{ p.description }}</div>
                <a v-if="p.url" :href="p.url" target="_blank" class="hero-cta pointer">selengkapnya</a>
              </div>
            </div>
          </slide>
        </carousel>
        <!-- <pre>{{ banner }}</pre> -->
      </div>
    </section>
    <section v-if="configs.profile_sekar" id="about" class="">
      <div class="container py-20">
        <span class="section-title font-size-h4 mb-15">Tentang Kami</span>
        <p class="font-size-h4 mb-0">{{ configs.profile_sekar }}</p>
      </div>
    </section>
    <section v-if="visimisi" id="visi-misi" class="">
      <div class="container py-20">
        <span class="section-title font-size-h4 mb-15">Visi & Misi</span>
        <div class="row">
          <div class="col-lg-5">
            <div class="d-flex flex-column">
              <span class="font-weight-bold font-size-h4" style>Visi Sekar HK</span>
              <span class="d-block pr-30 font-weight-boldest font-size-xl mb-3">{{ visimisi.vision }}</span>
              <!-- <p class="font-size-h4 mb-0">{{ configs.tagline }}</p> -->
            </div>
          </div>
          <div class="col-lg-7">
            <span class="font-weight-bold font-size-h4" style>Misi Sekar HK</span>
            <table>
              <tr v-for="(misi, index) in visimisi.mission" :key="index + '-misi'">
                <td class="font-size-h4 pr-4 pt-5" style="vertical-align:top">
                  <i class="ri-check-double-line text-dark"></i>
                </td>
                <td class="font-size-h4 pt-5">
                  {{ misi.label }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </section>
    <section v-if="configs.url_embed_video" id="gallery" class="" :style="{ 'background-image': 'linear-gradient(180deg, rgba(1, 156, 215, 0.25) 0%, rgba(1, 156, 215, 0)', 'background-size': 'auto 70%', 'background-repeat': 'no-repeat', 'background-position': 'center bottom' }">
      <div class="container py-20">
        <div class="iframe-wrapper">
          <youtube width="100%" height="600px" :video-id="$youtube.getIdFromUrl(configs.url_embed_video)" ref="youtube"></youtube>
        </div>
      </div>
    </section>
    <section v-if="gallery.length" id="gallery-folder" class="">
      <div class="container py-20">
        <!-- <pre>{{gallery}}</pre> -->
        <span class="section-title font-size-h4 mb-5">Gallery</span>
        <span class="d-block mb-15 font-weight-boldest font-size-xl">Album Foto dari Sekar HK</span>
        <div class="news">
          <carousel
            loop
            autoplay
            :autoplayTimeout="5000"
            :speed="2000"
            :perPageCustom="[
              [480, 1],
              [768, 3],
              [1199, 4],
            ]"
            paginationActiveColor="var(--secondary-theme)"
            :paginationSize="8"
            :paginationPosition="'bottom'"
          >
            <slide v-for="(n, i) in gallery" :key="i + '-img-gallery'">
              <div @click="redirect('gallery_folders', n)" class="card card-custom mr-5 card-up bg-transparent pointer">
                <div class="card-body p-0 bg-transparent">
                  <img v-if="n.img_cover" v-img-fb="n.img_cover" class="img-news-thumb mb-5" />
                  <img v-else src="static/img/default/no-photo.png" class="img-news-thumb mb-5" />
                  <span class="font-weight-bolder font-size-h5 text-line-2" style="line-height:1.25">{{ n.name }}</span>
                  <span class="d-block my-2 font-weight-light text-dark-75">{{ n.created_at | parse('longDateTime') }}</span>
                  <div class="d-flex align-items-center">
                    <div class="symbol symbol-20 symbol-lg-30 symbol-circle mr-3">
                      <img alt="Pic" src="static/img/default/no-profile-new.png" />
                    </div>
                    <span class="text-gray font-weight-bolder nowrap">{{ n.rel_created_by }}</span>
                    <span class="text-grey mx-1">|</span>
                    <div class="text-secondary text-line-1" style="word-break: break-all;">
                      <template v-for="kw in n.keywords">#{{ kw }}</template>
                    </div>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
    </section>
    <section v-if="news.length" id="news" class="">
      <div class="container py-20">
        <span class="section-title font-size-h4 mb-5">Berita</span>
        <span class="d-block mb-15 font-weight-boldest font-size-xl">Kabar Terbaru dari Sekar HK</span>
        <div class="news">
          <carousel
            loop
            autoplay
            :autoplayTimeout="5000"
            :speed="2000"
            :perPageCustom="[
              [480, 1],
              [768, 3],
              [1199, 4],
            ]"
            paginationActiveColor="var(--secondary-theme)"
            :paginationSize="8"
            :paginationPosition="'bottom'"
          >
            <slide v-for="(n, i) in news" :key="i + '-img-news'">
              <div @click="redirect('news', n)" class="card mr-5 card-custom card-up bg-transparent pointer">
                <div class="card-body p-0 bg-transparent">
                  <img v-if="n.img_cover" v-img-fb="n.img_cover" class="img-news-thumb mb-5" />
                  <img v-else src="static/img/default/no-photo.png" class="img-news-thumb mb-5" />
                  <span class="font-weight-bolder font-size-h5 text-line-2" style="line-height:1.25">{{ n.title }}</span>
                  <span v-if="n.rel_category_id" class="label label-inline px-4 font-weight-bold mt-2 text-secondary bg-light-secondary rounded-xl">{{ n.rel_category_id }}</span>
                  <span class="d-block my-2 font-weight-light text-dark-75">{{ n.created_at | parse('longDateTime') }}</span>
                  <div class="d-flex align-items-center">
                    <div class="symbol symbol-20 symbol-lg-30 symbol-circle mr-3">
                      <img alt="Pic" v-if="n.img_photo_created_by" :src="n.img_photo_created_by.url" />
                      <img alt="Pic" v-else src="static/img/default/no-profile-new.png" />
                    </div>
                    <span class="text-gray font-weight-bolder nowrap">{{ n.rel_created_by }}</span>
                    <span class="text-grey mx-1">|</span>
                    <div class="text-secondary text-line-1" style="word-break: break-all;">
                      <template v-for="kw in n.keywords">#{{ kw }}</template>
                    </div>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
          <!-- <pre>{{ news }}</pre> -->
        </div>
      </div>
    </section>
    <section v-if="vote" id="vote" class="">
      <div class="container py-20">
        <span class="section-title font-size-h4 mb-5">Highlight Vote</span>
        <span class="d-block font-weight-boldest font-size-xl mb-15">{{ vote.name }}</span>
        <!-- <p class="font-size-h4 mb-15">{{ vote.description }}</p> -->
        <div class="vote">
          <carousel
            loop
            autoplay
            :autoplayTimeout="5000"
            :speed="2000"
            :perPageCustom="[
              [480, 1],
              [768, 3],
              [1199, 4],
            ]"
            paginationActiveColor="var(--secondary-theme)"
            :paginationSize="8"
            :paginationPosition="'bottom'"
          >
            <slide v-for="(n, i) in vote.options" :key="i + '-img-vote'" class="">
              <div @click="redirect('config_votings', vote)" class="card card-custom mr-5 rounded-xl card-stretch pointer">
                <div class="card-body d-flex flex-column justify-content-between text-center">
                  <div>
                    <span class="d-block font-weight-bolder font-size-h6 text-muted mb-3" style="line-height:1.25">Pilihan #{{ i + 1 }}</span>
                    <span class="d-block font-weight-bold font-size-h5 text-line-2 mb-5" style="line-height:1.25">{{ n.label }}</span>
                    <img v-if="n.img_option" v-img-fb="n.img_option" class="img-news-thumb mb-0" />
                    <img v-else src="static/img/default/no-photo.png" class="img-news-thumb mb-0" />
                    <div class="my-2 text-line-3 font-weight-light text-dark">{{ n.description }}</div>
                  </div>
                  <div v-if="vote.voting_type === 'open'">
                    <hr style="border-color: #B5B5C3; border-width:2px" />
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <div class="symbol symbol-45 symbol-light-primary mr-2">
                          <span class="symbol-label">
                            <i class="text-primary ri-pushpin-line ri-2x"></i>
                          </span>
                        </div>
                        <div class="d-flex flex-column flex-grow-1 align-items-start">
                          <span class="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1">{{ n.total_vote }}</span>
                          <span class="text-muted font-weight-bold">suara</span>
                        </div>
                      </div>
                      <div class="d-flex align-items-center">
                        <div class="symbol symbol-45 symbol-light-warning mr-2">
                          <span class="symbol-label">
                            <i class="text-warning ri-percent-line ri-2x"></i>
                          </span>
                        </div>
                        <div class="d-flex flex-column flex-grow-1 align-items-start">
                          <span class="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1">{{ n.percent_vote }}%</span>
                          <span class="text-muted font-weight-bold">persen</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
          <!-- <pre>{{ vote }}</pre> -->
        </div>
      </div>
    </section>
    <section v-if="voting.length" id="voting" class="" :style="{ 'background-image': 'linear-gradient(180deg, rgba(1, 156, 215, 0.25) 0%, rgba(1, 156, 215, 0)', 'background-size': 'auto 100%', 'background-repeat': 'no-repeat', 'background-position': 'center bottom' }">
      <div class="container py-20">
        <span class="section-title font-size-h4 mb-5">Vote</span>
        <span class="d-block mb-15 font-weight-boldest font-size-xl">
          Tentukan Pilihan Anda
          <br />
          untuk SEKAR HK Menjadi Lebih Baik
        </span>
        <div class="Voting">
          <carousel
            loop
            autoplay
            :spacePadding="0"
            :autoplayTimeout="5000"
            :speed="2000"
            :perPageCustom="[
              [390, 1],
              [480, 1],
              [768, 1],
              [1199, 2],
            ]"
            paginationActiveColor="var(--secondary-theme)"
            :paginationSize="8"
            :paginationPosition="'bottom'"
          >
            <slide v-for="(n, i) in voting" :key="i + '-img-voting'">
              <div class="card card-custom card-up bg-transparent">
                <div class="card-body bg-transparent">
                  <img v-if="n.img_cover" v-img-fb="n.img_cover" class="img-voting-thumb mb-5" />
                  <img v-else src="static/img/default/no-photo.png" class="img-voting-thumb mb-5" />
                  <div class="row justify-content-between">
                    <div class="col-12 col-lg-8">
                      <div class="d-flex flex-wrap align-items-center">
                        <i class="ri-calendar-todo-line font-weight-bold mr-2"></i>
                        <span class="d-block font-weight-light text-dark-75">{{ n.start_date | parse('longDate') }}</span>
                        <span class="d-block font-weight-light text-dark-75 mx-1">-</span>
                        <span class="d-block font-weight-light text-dark-75">{{ n.end_date | parse('longDate') }}</span>
                      </div>
                      <span class="mb-2 font-weight-bolder font-size-h5 text-line-2" style="line-height:1.25">{{ n.name }}</span>
                      <div class="d-flex align-items-center">
                        <span class="label label-lg label-primary label-inline font-weight-bolder py-4 mr-3">{{ n.total_vote }} voted</span>
                        <span class="label label-lg label-light-primary label-inline py-4">
                          <span class="font-weight-bolder pr-1">{{ n.total_abstain }}</span>
                          left
                        </span>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4 mt-4 mt-lg-0 pl-lg-0 align-self-end">
                      <button @click="redirect('config_votings', n)" class="btn btn-success btn-lg">
                        <i class="ri-arrow-right-circle-fill pr-3"></i>
                        Vote Sekarang
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
          <!-- <pre>{{ voting }}</pre> -->
        </div>
      </div>
    </section>
    <!-- <section v-if="kritik.length" id="kritik" class="">
      <div class="container py-20">
        <span class="section-title font-size-h4 mb-5">Feedback</span>
        <span class="d-block mb-15 font-weight-boldest font-size-xl">Kritik & Saran</span>
        <div class="news">
          <carousel
            loop
            autoplay
            :autoplayTimeout="5000"
            :speed="2000"
            :perPageCustom="[
              [480, 1],
              [768, 3],
              [1199, 3],
            ]"
            paginationActiveColor="var(--secondary-theme)"
            :paginationSize="8"
            :paginationPosition="'bottom'"
          >
            <slide v-for="(n, i) in kritik" :key="i + '-img-kritik'">
              <div class="card mr-5 card-custom card-stretch card-up pointer rounded-xl">
                <div class="card-body">
                  <div class="d-flex justify-content-between">
                    <i class="ri-chat-quote-line ri-3x"></i>
                    <span class="text-muted text-italic pt-3">{{ n.rel_category_name }}</span>
                  </div>
                  <p class="font-size-h4 text-line-5">{{ n.description }}</p>
                  <span class="text-muted text-italic pt-3">- {{ n.name }}</span>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
    </section> -->
  </div>
</template>
<script>
export default {
  name: 'landing-landing',
  props: ['configs'],
  data () {
    return {
      isLoading: true,
      banner: [],
      visimisi: null,
      gallery: [],
      news: [],
      vote: null,
      voting: [],
      kritik: []
    }
  },
  mounted () {
    this.$store.commit('set', ['appcode', this.$_config.code, true])
    this.getData()
  },
  watch: {
    '$route.query.opm': {
      immediate: true,
      deep: true,
      handler (e) {
        if (e) {
          try {
            this.$bvModal.show('modal-login')
          } catch (error) {
            console.log('err')
          }
        }
      }
    }
  },
  methods: {
    getAPI (method, api, param, obj = null) {
      return this.$_api[method](api, param)
        .then((res) => {
          return obj ? res.data[obj] || res.data : res.data
        })
        .catch((err) => {
          this.$_alert.error(err)
        })
    },
    async getData () {
      this.banner = await this.getAPI('get', 'no-auth/banner/list')
      this.visimisi = await this.getAPI('get', 'no-auth/vision-mission')
      this.gallery = await this.getAPI('get', 'no-auth/gallery-folders/list')
      this.news = await this.getAPI('get', 'no-auth/news/list')
      this.vote = await this.getAPI('get', 'no-auth/highlight-voting')
      this.voting = await this.getAPI('get', 'no-auth/voting/list')
      // this.kritik = await this.getAPI('get', 'no-auth/feedback-suggestions/list')
      this.isLoading = false
    },
    getYTid (e) {
      // return 'https://youtube.com/embed/' + this.$youtube.getIdFromUrl(e.video) + '?playlist=' + this.$youtube.getIdFromUrl(e.video) + '&autoplay=1&controls=0&loop=1&mute=1'
      return 'https://youtube.com/embed/' + this.$youtube.getIdFromUrl(e.video)
    },
    redirect (e, data) {
      let target = null
      let params = {}
      switch (e) {
        case 'news':
          target = 'sekar-news'
          params = { pid: data.id, code: data.code }
          break
        case 'gallery_folders':
          target = 'sekar-gallery'
          params = { pid: data.id, code: data.code }
          break
        case 'config_votings':
          target = 'sekar-vote'
          params = { pid: data.id, code: data.code }
          break
        case 'forums':
          target = 'sekar-forum'
          params = { pid: data.id, code: data.code }
          break
        default:
          target = null
          break
      }
      if (target) {
        this.$router.push({ name: target, query: params })
      }
    }
  }
}
</script>
<style lang="">
  .section-title {
    display: block;
    position: relative;
    font-weight: 600;
    padding-left: 55px;
  }
  .section-title:before {
    content: '';
    position: absolute;
    left: 0;
    top: calc(50% - 1px);
    width: 35px;
    height: 1px;
    border-top: 4px solid var(--secondary-theme);
  }

  .hero-banner {
    min-height: 70vh;
    padding: 68px;
  }
  .hero-banner .hero-caption {
    font-size: 18px;
    font-weight: 600;
    color: var(--white);
  }
  .hero-banner .hero-cta {
    font-size: 15px;
    color: var(--white);
    text-decoration: underline;
  }
  @media only screen and (min-width: 1190px) {
    .hero-banner .hero-caption {
      font-size: 38px;
      max-width: 60%;
    }
    .hero-banner .hero-cta {
      font-size: 25px;
    }
  }

  .iframe-wrapper iframe {
    -moz-border-radius: 23px;
    border-radius: 23px;
    overflow: hidden;
  }
  .img-news-thumb {
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: 23px;
    object-fit: cover;
  }
  .img-voting-thumb {
    width: 100%;
    aspect-ratio: 1 / 0.5;
    border-radius: 23px;
    object-fit: cover;
  }
</style>



// WEBPACK FOOTER //
// src/landing-page/landing.vue